import { theme, useResponsive } from "@product/scmp-sdk";
import { useAtom } from "jotai";

import { registerEmailCookieAtom } from "~/lib/account";

import { AccountActivation } from ".";

export const useAccountActivation = () => {
  const isDesktopUp = useResponsive(theme.breakpoints.up("desktop"), false);
  const [registerEmail, updateRegisterEmailCookie] = useAtom(registerEmailCookieAtom);
  if (!registerEmail || !isDesktopUp) return;
  return (
    <AccountActivation email={registerEmail} onClose={() => updateRegisterEmailCookie(null)} />
  );
};
